<template>
  <b-row>
    <b-col sm="12" md="8">
      <my-card title="Sortir" collapsed :badge="$store.getters['purchases/isFiltered'] ? 'Filtered':''">
        <template slot="body">
          <form @submit.prevent="submitFilter">
            <b-row>
              <b-col sm="12">
                <form-select-new :filter-id="idBranchArray" url="v1/branch_select2" :queryparams="{id_regional: mainRegionalId}" v-model="filter.branch" label="Cabang"></form-select-new>
              </b-col>
              <b-col sm="6">
                <form-date :max="maxDate" v-model="filter.date_1" label="Tanggal Mulai"></form-date>
              </b-col>
              <b-col sm="6">
                <form-date :min="minDate" v-model="filter.date_2" label="Tanggal Selesai"></form-date>
              </b-col>
              <b-col sm="12">
                <form-select-new url="v1/supplier_select2" v-model="filter.supplier" label="Pemasok"></form-select-new>
              </b-col>
              <b-col sm="12">
                <form-select-static :options="utils.statuses" v-model="filter.status" label="Status"></form-select-static>
              </b-col>
              <b-col sm="12">
                <button-action size="sm" @clicked="submitFilter" name="Filter" featherIcon="FilterIcon"></button-action>
                <button-action size="sm" @clicked="resetFilter" name="Reset" variant="warning"></button-action>
                <button-action v-if="cP(132)" size="sm" @clicked="exportExcel" variant="warning" name="Export"></button-action>
              </b-col>
            </b-row>
          </form>
        </template>
      </my-card>
    </b-col>
    <b-col sm="12">
      <my-card title="Daftar Pembelian">
        <template slot="button">
          <button-add v-if="cP(87)" :to="{name: 'purchases-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables sort-key="3" desc ref="datatables" endpoint="v1/purchases" :query-params="filterQuery" :fields="fields">
            <template v-slot:1="{item}">
              <b-badge v-if="item[1]===`(belum ada pembelian)`" variant="warning">{{item[1]}}</b-badge>
              <span v-else>{{item[1]}}</span>
            </template>
            <template v-slot:3="{item}">
              {{item[3] | mindate}}
            </template>
            <template v-slot:6="{item}">
              {{item[6] | formatNumber}}
            </template>
            <template v-slot:7="data">
              <button-link size="sm" :to="{name:'purchases-show',params:{id: data.item[7]}}" feather-icon="FolderIcon"></button-link>
              <div class="float-none" v-if="!data.item[8]">
                <button-link :disabled="data.item[5]==='Permintaan'" v-if="cP(89)" size="sm" :to="{name:'purchases-edit',params:{id: data.item[7]}}" :feather-icon="data.item[1]===`(belum ada pembelian)`?`PlusIcon`:`EditIcon`"></button-link>
                <button-delete v-if="cP(90)&&isPusat&&data.item[5]==='Pembelian'" @ondelete="deleteRow" :id="data.item[7]" :name="`${data.item[1]} (${data.item[2]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import ButtonAction from '@/my-components/ButtonAction.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'
import FormSelectNew from '@/my-components/FormSelectNew'
import FormSelectStatic from '@/my-components/FormSelectStatic'
import FormDate from '@/my-components/FormDate'
import { mapFields } from 'vuex-map-fields'
import utils from './utils'
import {BBadge} from 'bootstrap-vue'
import FileSaver from 'file-saver'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
    FormDate,
    ButtonAction,
    FormSelectStatic,
    BBadge,
    FormSelectNew
  },
  data() {
    return {
      utils:utils,
      fields: {
        0:{sortable: true, searchable: true, label:'Kode Permintaan'},
        1:{sortable: true, searchable: true, label:'Kode Pembelian'},
        2:{sortable: true, searchable: true, label:'Cabang'},
        3:{sortable: true, searchable: true, label:'Tanggal'},
        4:{sortable: true, searchable: true, label:'Pemasok'},
        5:{sortable: true, searchable: true, label:'Status'},
        6:{sortable: true, searchable: true, label:'Total'},
        7:{sortable: false, searchable: false, label:''},
      }
    }
  },
  computed:{
    ...mapFields('purchases',['filter']),
    filterQuery(){
      let filters = JSON.parse(JSON.stringify(this.filter))
      if(filters.branch) filters.id_branch = filters.branch.value
      if(filters.supplier) filters.id_supplier = filters.supplier.value
      delete filters.branch
      delete filters.supplier
      return filters
    },
    userProfile(){
      return this.$store.state.auth.profile
    },
    minDate(){
      const min = this.filter.date_1
      if(!min) return null
      else return this.$moment(min).format()
    },
    maxDate(){
      const max = this.filter.date_2
      if(!max) return null
      else return this.$moment(max).format()
    }
  },
  methods:{
    firstInit(){
      if(!this.isPusat) {
        if(!this.filter.branch)
        this.filter.branch = {value:this.userProfile.id_branch,label:this.userProfile.branch_name}
      }
    },
    submitFilter(){
      this.$refs.datatables.refresh()
    },
    resetFilter(){
      if(this.isPusat){
        this.filter.id_branch = ""
        this.filter.branch = null
      }
      this.filter.id_supplier = ""
      this.filter.supplier = null
      this.filter.date_1 = ""
      this.filter.date_2 = ""
      this.filter.status = ""
      this.$refs.datatables.refresh()
    },
    async deleteRow(payload){
      try {
        await this.$store.dispatch('purchases/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    },
    async exportExcel(){
      const filters = this.filterQuery
      try {
        const res = await this.$http.get(`v1/purchase_export`,{params:filters,responseType: 'blob'})
        FileSaver.saveAs(res.data,'PEMBELIAN')
      } catch (error) {
        this.handleError(error)
      }
    }
  },
  created(){
    this.firstInit()
  }
}
</script>

<style>

</style>